import type { FC } from "react";

import { useAgenticHomeEnabled } from "src/hooks/use-agentic-home-enabled";
import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";
import { lazyNamed } from "src/utils/lazy-named";

const homeImport = () => import("./home");
const Home = lazyNamed(homeImport, "Home");
const AgenticHome = lazyNamed(
  () => import("./agentic/agentic-home"),
  "AgenticHome",
);

export const preloads: RoutePreload[] = [["/home", homeImport]];

// Static (not lazy) because it calls a hook; the page components are lazy.
const HomeGate: FC = () => {
  const isAgenticHomeEnabled = useAgenticHomeEnabled();
  return isAgenticHomeEnabled ? <AgenticHome /> : <Home />;
};

export const routes: RouteObject[] = [
  {
    path: "home",
    spacesAccess: "hidden-from-limited-view",
    element: <HomeGate />,
  },
];
